import styled from 'vue-styled-components'
const OverlayHeader = styled.div`
    position: relative;
    /* z-index: 1; */
    z-index: 0;
    border-bottom: 1px solid var(--line);
    /* height: 75px; */
`
const OverlayBody = styled.div`
overflow-y: scroll;
`
const DetailName = styled.div`
/* font-size: 24px; */
`
const WrapperProps = {
    custom_style: {}
}
const Wrapper = styled('div', WrapperProps)`
&.mwe-overlay-layout {
    .b-sidebar {
        ${({ custom_style }) => custom_style.width && `width: ${custom_style.width}px;
        box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15);`};
    }
}
`

export {
    OverlayHeader,
    OverlayBody,
    DetailName,
    Wrapper
}